import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { ChangePurchaseTenderProcessingStatusMutationResponse, ChangePurchaseTenderProcessingStatusQueryParams } from "../../types/ChangePurchaseTenderProcessingStatus";

/**
     * @link /api/purchase-tenders/v1/tender/do_update-for-processing-status
     */
export async function changePurchaseTenderProcessingStatus (params: ChangePurchaseTenderProcessingStatusQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<ChangePurchaseTenderProcessingStatusMutationResponse>["data"]> {
    const { data: resData } = await client<ChangePurchaseTenderProcessingStatusMutationResponse>({
        method: "patch",
        url: `/api/purchase-tenders/v1/tender/do_update-for-processing-status`,
        params,
        ...options
    });
    
    return resData;
};